import React, { useEffect } from 'react';
import styled from 'styled-components';
import MagicModuleSwitcher from '@modules/MagicModuleSwitcher';
import { Page } from '@style/Shared';
import ArtistHero from '@client/modules/ArtistHero';
import { presetColors } from '@client/style/Variables';
import Functions from '@client/style/Functions';
import ContentPageStore, { IContentPageState } from '@client/store/ContentPageStore';
import SoMeBar from '@client/modules/SoMeBar';
import Menu from '@client/modules/Menu/Menu';
import GotoElement from '@client/core/utils/GotoElement';
import { boldTextStyle } from '@client/style/Text';
import WaveContainer from '@client/modules/Dividers/WaveContainer';
import BackgroundHazeSvg from '@client/assets/svgs/background-haze.svg';
import { TextStyle } from '@client/style/TextStyles';
import ArtistBackButton from '@client/modules/ArtistBackButton';

const BackgroundHaze = styled.div`
	position: fixed;
	top: 0px;
	left: -80vw;
	width: 250vw;
	height: 250vh;
	z-index: 0;
	pointer-events: none;
`;

const StyledSoMeContainer = styled.div`
	${boldTextStyle}
	margin-top: 80px;
	text-align: center;
	${TextStyle.size('p4')}
	white-space: pre-line;
`;

const StyledBottomContainer = styled(WaveContainer)`
	background: ${presetColors.blackish};
	height: calc(var(--breaker-height) + 200px);
`;

const StyledPage = styled(Page)<{ $fg?: string; $bg?: string }>`
	background-color: ${props => props.$bg} !important;
	color: ${props => props.$fg};
`;

export default function ContentPage(props: { content?: any }) {
	const themeColors: IContentPageState = ContentPageStore.use(state => state);

	useEffect(() => {
		if (props.content?.backgroundColor === null) {
			ContentPageStore.setBackgroundColor(Functions.hexFromRGB(props.content?.images[0].colors[0]));
		} else {
			ContentPageStore.setBackgroundColor(props.content?.backgroundColor);
		}
	}, []);

	return (
		<StyledPage $bg={themeColors.backgroundColor} $fg={themeColors.contrastColor}>
			<BackgroundHaze>
				<BackgroundHazeSvg />
			</BackgroundHaze>
			<Menu
				onLogoClick={() => GotoElement.Instance.scrollToElementWithId(`module_${props.content.startId}`)}
				specificColor={themeColors.contrastColor}
			/>
			<ArtistHero
				title={props.content.title}
				location={props.content.location}
				startTime={props.content.startTime}
				images={props.content.images}
				showTime={props.content.showTime}
				textColor={themeColors.contrastColor}
				artistId={props.content.id}
				tickets={
					props.content.ticketButtonLink
						? {
								link: props.content.ticketButtonLink,
								type: props.content.ticketButtonType,
							}
						: undefined
				}
			/>

			<ArtistBackButton theme={themeColors} />

			<MagicModuleSwitcher modules={props.content ? props.content.modules : []} />
			{props.content.socialMedia && props.content.socialMedia.length > 0 && (
				<StyledSoMeContainer>
					<p>{`Hvis du ikk\u2019 kan få nok\n ${props.content.title}`}</p>
					<SoMeBar entries={props.content.socialMedia}></SoMeBar>
				</StyledSoMeContainer>
			)}
			<StyledBottomContainer side='top'>{/* Other artists goes here later */}</StyledBottomContainer>
		</StyledPage>
	);
}
